// src/components/NotificationHandler.js
import React, { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { onMessageListener } from '../firebase';

const NotificationHandler = () => {
  useEffect(() => {
    const setupNotifications = async () => {
      try {
        
        const payload = await onMessageListener();
        if (payload && payload.notification) {
          const { title, body } = payload.notification;
          
          
          // Show toast notification
          toast.success(
            <div>
              <strong>{title}</strong>
              <div style={{ fontSize: '14px', marginTop: '5px' }}>{body}</div>
            </div>,
            {
              duration: 6000,
              position: 'top-right',
            }
          );

          // Show browser notification if permitted
          if ('Notification' in window && Notification.permission === 'granted') {
            const companyHeaderLogo = localStorage.getItem('company_header_logo');
            
            new Notification(title, {
              body: body,
              icon: companyHeaderLogo || '/logo192.png',
              badge: '/logo192.png',
              tag: 'garagemitra-notification'
            });
          }
        }
      } catch (error) {
        console.error('Error in notification handler:', error);
      }
    };

    setupNotifications();

    // Setup service worker for background notifications
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then((registration) => {
          console.log('Service Worker registered:', registration);
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    }
  }, []);

  return null; // This component doesn't render anything
};

export default NotificationHandler;